import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import plus from "../../assets/images/Icon feather-plus.png";
import SupplierContext from "context/SupplierContext";
import { AiFillPlusCircle } from "react-icons/ai";
import SinglePartitionNew from "./singlePartitionNew";
import Loader from "utils/Loader";

export default function SubLineProduct({ data, selectedFilter }) {
  // console.log("lineproduct", data.data);
  const { setProduct } = useContext(SupplierContext);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="mySwiper SinglePartition">
      {isLoading && <Loader />}
      {data.data != undefined && data.data.length > 0 ? (
        <div className="d-flex  flex-wrap ">
          {data.data.map((value, index) => {
            return (
              <div style={{ marginRight: "20px" }}>
                <SinglePartitionNew
                  value={value}
                  setProduct={setProduct}
                  type="supplier"
                ></SinglePartitionNew>
              </div>
            );
          })}
        </div>
      ) : (
        "محصولی وجود ندارد"
      )}
    </div>
  );
}
